@if (statLastDoc === true) {
  <div [ngClass]="isDesktop === true ? 'margin' : 'margin scroll-table'">
    <p-table
      #dt
      selectionMode="single"
      [columns]="listColumns"
      [value]="resultDisplay"
      [rows]="nbRow"
      [paginator]="false"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      (onRowSelect)="onRowSelect($event)"
      >
      <ng-template pTemplate="caption">
        <span class="header-grid-wrapper">
          <span class="align-right font-bold">{{'Last_DocW' | translate}}</span>
        </span>
      </ng-template>
      <ng-template let-columns pTemplate="header">
        <tr>
          @for (col of columns; track col; let i = $index) {
            <th
              [pSortableColumn]="col.field"
                    [ngClass]="{
                        'width-col-date': col.field === 'dateaction',
                        'width-col-action': col.field === 'codeaction' || col.field === 'acces',
                        'width-auto': col.field === 'docName'
                    }"
              >
              <p-sortIcon [field]="col.field"></p-sortIcon>
              <span>
                {{ col.header }}
              </span>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template let-rowData let-rowIndex="rowIndex" let-columns="columns" pTemplate="body">
        <tr [pSelectableRow]="rowData" class="table-row">
          @for (col of columns; track col; let i = $index) {
            <td
                [ngClass]="{
                    cursornot: rowData['acces'] === false
                }"
              >
              @switch (col.field) {
                @case ('dateaction') {
                    {{ rowData[col.field] | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                }
                @case ('acces') {
                  <div class="left">
                    @if (rowData[col.field] === true) {
                      <i
                        class="icons8-visible md-18"
                        pTooltip="{{'Access_OK' | translate}}"
                        tooltipPosition="top"
                      ></i>
                    } @else {
                      <i
                        class="icons8-invisible md-18"
                        pTooltip="{{'Access_KO' | translate}}"
                        tooltipPosition="top"
                        >
                      </i>
                    }
                  </div>
                }
                @case ('codeaction') {
                  <div class="left">
                    @switch (rowData[col.field]) {
                      @case (0) {
                        <i
                          class="pi pi-check md-18"
                          style="color: green"
                          pTooltip="{{'Validate' | translate}}"
                          tooltipPosition="top"
                        ></i>
                      }
                      @case (1) {
                        <i
                          class="pi pi-clone"
                          pTooltip="{{'Copy_W' | translate}}"
                          tooltipPosition="top"
                          ></i>
                      }
                      @case (2) {
                        <i
                          class="pi pi-arrows-h"
                          pTooltip="{{'Move' | translate}}"
                          tooltipPosition="top"
                        ></i>
                      }
                      @case (3) {
                        <i
                        class="icons8-trash-can md-18"
                        pTooltip="{{'Del_Bsk_Act' | translate}}"
                        tooltipPosition="top"
                        ></i>
                      }
                      @case (4) {
                        <i
                          class="icons8-trash-can md-18"
                          style="color: red"
                          pTooltip="{{'Del_Ged_Act' | translate}}"
                          tooltipPosition="top"
                        ></i>                        
                      }
                    }                   
                  </div>
                  }
                  @default {
                    {{ rowData[col.field] }}
                  }
                }
              </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td>{{'Empty_1' | translate}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
